import { v4 as uuidv4 } from 'uuid';
const guid = uuidv4();
// console.info('guid', guid);
const env = {
  test: '1snn5n9w',
  production: 'k8vif92e',
};
let orgId = '';
const merchantID = '';
// console.info('sessionId', sessionId);

/**风控指纹
/* https://h.online-metrix.net/fp/tags.js?org_id=<org ID>&session_id=<merchant ID><session ID>
 */

export function riskCreateJs() {
  const script = document.createElement('script');
  let sessionId = getSessionId();
  sessionId = 'litepaycompanylimited' + sessionId;
  script.type = 'text/javascript';
  script.src = `https://h.online-metrix.net/fp/tags.js?org_id=${orgId}&session_id=${sessionId}`;
  document.head.appendChild(script);
}

export function getSessionId() {
  const hostname = location.hostname;
  if (hostname === 'secure-checkout.lianlianpay.com') {
    orgId = env['production'];
  } else if (hostname === 'gpcashier.lianlianpay-inc.com') {
    orgId = env['test'];
  } else {
    orgId = env['test'];
  }
  const sessionId = merchantID + guid;
  return sessionId;
}

export function BrSessionId() {

  (function (a, b, c, d, e, f, g, h) {
    a['CsdpObject'] = e; a[e] = a[e] || function () {
    (a[e].q = a[e].q || []).push(arguments)
    }, a[e].l = 1 * new Date(); f = b.createElement(c),
    g = b.getElementsByTagName(c)[0]; f.async = 1; f.src = d; g.parentNode.insertBefore(f, g);
    if('integrity' in f) {
      f.crossOrigin = 'anonymous';
      f.integrity = h;
    }
    f.onerror = (event) => {
      // 获取更多错误信息
      const errorInfo = {
        message: event?.message || 'Unknown error',
        filename: event?.filename || '',
        lineno: event?.lineno || '',
        colno: event?.colno || '',
        error: event?.error || ''
      };
      console.error('Error loading script /counterjs/fp.js:', event);
      throw new Error(`Error loading ${window.location.origin}${d}:${JSON.stringify(errorInfo)}`);
    };
    })(window, document, 'script', '/counterjs/fp.js', 'csdp', undefined, undefined, 'sha384-lwwCKQ9LH1OebaJQaR56yUvB2z20UDvivERvQ2JHqPViwvxqn42Hz6LxXstStVub');
    csdp('app', 'dmt1ryjay8sknnin005g');
    csdp('outputsessionid', 'sessionId');

}
